import { faPen } from '@fortawesome/pro-regular-svg-icons/faPen';
import { Icon } from '@kontentino/ui';
import { ActionContext, createAction } from 'actions';
import i18n from 'app/utils/i18n';
import { UserPermission } from 'constants/userPermission';

export const editReport = (context: ActionContext) =>
  createAction(
    {
      id: 'edit-report',
      label: () => i18n.t('edit'),
      icon: <Icon icon={faPen} />,
      scopes: UserPermission.REPORT_EDIT,
      perform: ({ id }: { id: number }) => {
        context.navigate(`/reports/${id}/edit`);
      },
    },
    context,
  );
